import React from 'react';
import { Box } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

/**
 * Rendu Markdown des réponses de l'assistant (listes, gras, tableaux GFM).
 * Pas de HTML brut : react-markdown l'ignore par défaut (pas d'injection).
 * Les liens (ex. PDF d'un proforma) s'ouvrent dans un nouvel onglet.
 */
const AssistantMarkdown: React.FC<{ text: string }> = ({ text }) => (
  <Box
    sx={{
      fontSize: '0.875rem',
      lineHeight: 1.55,
      color: '#101828',
      wordBreak: 'break-word',
      '& p': { my: 0.75 },
      '& p:first-of-type': { mt: 0 },
      '& p:last-of-type': { mb: 0 },
      '& ul, & ol': { my: 0.75, pl: 2.5 },
      '& li': { my: 0.25 },
      '& a': { color: '#2563eb' },
      '& code': { bgcolor: '#f4f5f7', px: 0.5, borderRadius: 0.5, fontSize: '0.8rem' },
      '& table': { borderCollapse: 'collapse', my: 1, width: '100%', fontSize: '0.8rem', display: 'block', overflowX: 'auto' },
      '& th, & td': { border: '1px solid #e4e7ec', px: 1, py: 0.5, textAlign: 'left', whiteSpace: 'nowrap' },
      '& th': { bgcolor: '#f4f5f7', fontWeight: 600 },
    }}
  >
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        a: ({ node, children, ...props }) => (
          <a {...props} target="_blank" rel="noopener noreferrer">{children}</a>
        ),
      }}
    >
      {text}
    </ReactMarkdown>
  </Box>
);

export default AssistantMarkdown;
